import _reduce from 'lodash/reduce'
import { connect } from 'react-redux'
import { selectors } from '../../features/Settings'
import { selectors as loadingBarSelectors } from '../../features/LoadingBar'
import User from '../../components/User'
import localize from '../../store/localize'
import strings from '../../components/User/user.json'
import {
    actionUsersSetUserPinnedState,
    actionUsersLogOutUser,
    actionUsersSetUserAutoLaunchState,
    actionUsersSetUserMultiLaunchState,
    actionProcessSetProgress,
    actionProfileShowSelector,
    actionProfileHideSelector,
} from '../../actions'

// Check if we have a user list available
// if one is available, count the entries
function getUserCount(users, server) {
    if (users.list == null || users.list[server] == null) return 0

    return _reduce(
        users.list[server],
        (r, v) => {
            if (v.shell === true) return r
            return r + 1
        },
        0,
    )
}

function mapStateToProps(state, ownProps) {
    const { servers, users, processes, profile } = state
    const progress = loadingBarSelectors.getProgress(state)
    const server = servers.list[servers.active]
    const user = users.list[server.shortName][ownProps.username]
    // Display toggle if more than one user
    const displayToggle = getUserCount(users, server.shortName) > 1

    // todo: play -- this should listen to a single bool in state
    const playEnabled =
        // progress == null ||
        progress.percent === 0 || progress.percent === 100

    let process = {}
    try {
        process = processes[server.shortName][user.username]
        if (process === undefined) {
            process = {
                isRunning: false,
                progress: 0,
                progressName: '',
            }
        }
    } catch (error) {
        process = {
            isRunning: false,
            progress: 0,
            progressName: '',
        }
    }

    return {
        server,
        user,
        displayToggle,
        localize: value => localize(strings, selectors.getLanguage(state), value),
        process,
        selectorShowing: profile.open,
        playEnabled,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPinnedState: (server, username, pinned) => {
            dispatch(actionUsersSetUserPinnedState(server, username, pinned))
        },
        setMultiLaunchState: (server, username, multiLaunch) => {
            dispatch(actionUsersSetUserMultiLaunchState(server, username, multiLaunch))
        },
        setAutoLaunch: (server, username, autoLaunch) => {
            dispatch(actionUsersSetUserAutoLaunchState(server, username, autoLaunch))
        },
        remove: (server, username) => {
            dispatch(actionUsersLogOutUser(server, username))
        },
        setClientLaunchProgress: (server, username, progress) => {
            dispatch(actionProcessSetProgress(server, username, progress))
        },
        toggleProfileSelector: (server, username, show, boundingRectangle, title) => {
            if (show) {
                dispatch(actionProfileShowSelector(server, username, boundingRectangle, title))
            } else {
                dispatch(actionProfileHideSelector())
            }
        },
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        server: stateProps.server,
        user: stateProps.user,
        displayToggle: stateProps.displayToggle,
        process: stateProps.process,
        launchClient: ownProps.launchClient,
        localize: stateProps.localize,
        playEnabled: stateProps.playEnabled,
        togglePinnedState: () => {
            dispatchProps.setPinnedState(
                stateProps.server.shortName,
                stateProps.user.username,
                !stateProps.user.remember,
            )
        },
        setMultiLaunchState: () => {
            dispatchProps.setMultiLaunchState(
                stateProps.server.shortName,
                stateProps.user.username,
                !stateProps.user.multiLaunch,
            )
        },
        setAutoLaunch: () => {
            dispatchProps.setAutoLaunch(
                stateProps.server.shortName,
                stateProps.user.username,
                false,
            )
        },
        remove: () => {
            dispatchProps.remove(stateProps.server.shortName, stateProps.user.username)
        },
        setClientLaunchProgress: (progress) => {
            dispatchProps.setClientLaunchProgress(
                stateProps.server.shortName,
                stateProps.user.username,
                progress,
            )
        },
        toggleProfileSelector: (boundingRectangle, title) => {
            dispatchProps.toggleProfileSelector(
                stateProps.server.shortName,
                stateProps.user.username,
                !stateProps.selectorShowing,
                boundingRectangle,
                title,
            )
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(User)



// WEBPACK FOOTER //
// ./src/containers/User/user.js